export const formatCurrency = (
  value,
  {
    withSign = false,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2
  } = {}
) => {
  const numberValue = Number(value);
  const safeValue = Number.isFinite(numberValue) ? numberValue : 0;
  const absValue = Math.abs(safeValue);
  const formatted = absValue.toLocaleString(undefined, {
    minimumFractionDigits,
    maximumFractionDigits
  });
  const sign = withSign ? (safeValue > 0 ? '+' : safeValue < 0 ? '-' : '') : '';

  return `${sign}KSH ${formatted}`;
};
